// SubtaskItem.js - اصلاح شده
import React, { useState } from 'react';
import { 
  Checkbox, 
  Button, 
  Space, 
  Typography, 
  Tooltip, 
  Input 
} from 'antd';
import { 
  EditOutlined, 
  DeleteOutlined, 
  DragOutlined 
} from '@ant-design/icons';

const { Text } = Typography;

const SubtaskItem = ({ subtask, onToggle, onDelete, onEdit, isDragging = false, style = {} }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editValue, setEditValue] = useState(subtask.content);

  const handleEditSubmit = () => {
    if (editValue.trim()) {
      onEdit(subtask.id, editValue.trim());
      setIsEditing(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleEditSubmit();
    } else if (e.key === 'Escape') {
      setEditValue(subtask.content);
      setIsEditing(false);
    }
  };

  return (
    <div
      style={{
        ...style,
        opacity: isDragging ? 0.5 : 1,
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          padding: '12px 16px',
          marginBottom: '8px',
          background: subtask.completed ? '#f6ffed' : '#fafafa',
          border: `1px solid ${subtask.completed ? '#b7eb8f' : '#e8e8e8'}`,
          borderRadius: '8px',
          transition: 'all 0.2s ease',
          cursor: 'grab',
        }}
        onDoubleClick={() => setIsEditing(true)}
      >
        {/* Drag Handle */}
        <div 
          style={{ 
            display: 'flex', 
            flexDirection: 'column',
            cursor: 'grab',
            padding: '4px',
            borderRadius: '4px',
            color: '#bfbfbf'
          }}
          className="drag-handle"
        >
          <DragOutlined />
        </div>

        {/* Checkbox */}
        <Checkbox
          checked={subtask.completed}
          onChange={() => onToggle(subtask.id)}
          style={{ marginTop: '2px' }}
        />

        {/* Content */}
        <div style={{ flex: 1, minWidth: 0 }}>
          {isEditing ? (
            <Input
              value={editValue}
              onChange={(e) => setEditValue(e.target.value)}
              onBlur={handleEditSubmit}
              onKeyDown={handleKeyPress}
              autoFocus
              size="small"
              style={{ 
                background: 'white',
                border: '1px solid #1890ff'
              }}
            />
          ) : (
            <Text
              style={{
                textDecoration: subtask.completed ? 'line-through' : 'none',
                color: subtask.completed ? '#8c8c8c' : '#262626',
                fontSize: '14px',
                lineHeight: '1.4',
                cursor: 'text'
              }}
            >
              {subtask.content}
            </Text>
          )}
        </div>

        {/* Actions */}
        <Space size={4}>
          <Tooltip title="Edit">
            <Button
              type="text"
              icon={<EditOutlined />}
              size="small"
              onClick={() => setIsEditing(true)}
              style={{ color: '#1890ff' }}
            />
          </Tooltip>
          <Tooltip title="Delete">
            <Button
              type="text"
              danger
              icon={<DeleteOutlined />}
              size="small"
              onClick={() => onDelete(subtask.id)}
            />
          </Tooltip>
        </Space>
      </div>
    </div>
  );
};

export default SubtaskItem;